import React, { useState } from 'react'
import { useDispatch } from 'react-redux';

import {
    Grid,
    Paper,
    Button,
    makeStyles,
    Chip,
    Typography,
} from "@material-ui/core";

import Buscador from '../../../actions/ui/Buscador'
import { startAlerta } from '../../../actions/ui/alertas';
import { GenericModal } from '../../atomic/organisms/GenericModal';
import { ALCANCE_DISCAPACIDAD_LIST, FRECUENCIA_DISCAPACIDAD_LIST, TIPO_DISCAPACIDAD_LIST } from '../data/constants';
import { SelectGeneric } from '../../atomic/atoms/Select';

const buttonStyle = {
    textAlign: 'center'
}

const useStyles = makeStyles((theme) => ({
    chip: {
        margin: theme.spacing(0.5),
    },
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: "0.5em 0 0",
    },
}));

const initModal = {
    open: false,
    value: null
}

export const DiagnosticosForm = ({ formValues, setearValor }) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [diagnostico, setDiagnostico] = useState(null);

    const [modal, setModal] = useState(initModal);

    const insertValue = () => {
        if (formValues.diagnosticos.length < 10) {
            if (diagnostico !== null) {
                const existeDiagnostico = formValues.diagnosticos.find(item => item.codCie10 === diagnostico.codCie10);
                if (!existeDiagnostico) {
                    setModal({
                        open: true,
                        value: {
                            codCie10: diagnostico.codCie10,
                            descripcion: diagnostico.descripcion
                        }
                    });
                } else {
                    dispatch(startAlerta(
                        "Ya se cargo este diagnostico",
                        "warning"
                    ));
                }
                setDiagnostico(null);
            }
        } else {
            dispatch(startAlerta(
                "Solo puede ingresar máximo 10 diagnósticos",
                "warning"
            ));
        }
    }

    const handleSubmit = (values) => {
        setearValor("diagnosticos",
            formValues.diagnosticos.some(d => d.codCie10 === values.codCie10) ?
                formValues.diagnosticos.map(item => item.codCie10 === values.codCie10 ? values : item)
                :
                [
                    ...formValues.diagnosticos,
                    values
                ]);
        setModal(initModal);
    }

    return (
        <>
            <Paper style={{ padding: "1em" }}>
                <Grid container spacing={1} justify='center' alignItems='center'>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={2} style={{ padding: "1em" }}>
                            <Grid container direction='column' spacing={2}>
                                <Grid item xs={12}>
                                    <Buscador
                                        value={diagnostico}
                                        setValue={(val) => setDiagnostico(val)}
                                        label="Diagnostico"
                                        endpoint={(param) => `Discapacidad/CIE10?parametroBusqueda=${param}`}
                                        noOptionText={"No se encuentran diagnosticos"}
                                        getOptionLabel={(option) => `${option.codCie10} - ${option.descripcion}`}
                                    />
                                </Grid>
                                <Grid item xs={12} style={buttonStyle}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        onClick={insertValue}
                                    >
                                        + AGREGAR
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={8} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", margin: "0.5em 0 0" }}>
                        <Typography variant="button">Diagnósticos agregados</Typography>
                        <div className={classes.root}>
                            {formValues.diagnosticos.length > 0 ? (
                                formValues.diagnosticos.map((diagnostico, index) => (
                                    <Chip
                                        key={index}
                                        label={
                                            `${diagnostico.codCie10} - ${diagnostico?.descripcion}`
                                        }
                                        onDelete={() => setearValor(
                                            "diagnosticos",
                                            formValues.diagnosticos.filter(e => e.codCie10 !== diagnostico.codCie10)
                                        )}
                                        className={classes.chip}
                                        style={{ width: "250px", cursor: "pointer", display: "flex", justifyContent: "space-between", paddingLeft: "0.5em" }}
                                        onClick={() => { setModal({ open: true, value: diagnostico }) }}
                                    />
                                ))
                            ) : (
                                <Typography style={{ color: "#777", fontWeight: "lighter" }}>No se agregaron diagnosticos</Typography>
                            )
                            }
                        </div>
                    </Grid>
                </Grid>
            </Paper>
            {modal.open && (
                <FormDiagnostico
                    modal={modal}
                    handleClose={() => setModal(initModal)}
                    submit={handleSubmit}
                />
            )}
        </>
    )
}

const FormDiagnostico = ({ modal, handleClose, submit }) => {
    const [values, setValues] = useState({
        ...modal.value,
        idTipoDiscapacidad: modal.value.idTipoDiscapacidad || "",
        idFrecuenciaDiscapacidad: modal.value.idFrecuenciaDiscapacidad || "",
        idAlcanceDiscapacidad: modal.value.idAlcanceDiscapacidad || "",
    });

    return (
        <GenericModal
            handleButton={() => submit(values)}
            open={modal.open}
            title={`${modal.value.codCie10} - ${modal.value.descripcion}`}
            gridStyle={{ textAlign: 'center', padding: '1em' }}
            handleClose={handleClose}
            disabledButton={!values.idTipoDiscapacidad || !values.idFrecuenciaDiscapacidad || !values.idAlcanceDiscapacidad}
            textButton="Seleccionar"
        >
            <Grid container spacing={2} style={{ padding: 0, margin: 0 }}>
                <Grid item xs={12}>
                    <SelectGeneric
                        label="Tipo de discapacidad"
                        value={values.idTipoDiscapacidad}
                        onChange={e => {
                            setValues({
                                ...values,
                                idTipoDiscapacidad: e.target.value,
                                idFrecuenciaDiscapacidad: "",
                                idAlcanceDiscapacidad: ""
                            })
                        }}
                        menuItems={TIPO_DISCAPACIDAD_LIST.map(s => ({ value: s.id, label: s.descripcion }))}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SelectGeneric
                        label="Periodo de discapacidad"
                        value={values.idFrecuenciaDiscapacidad}
                        onChange={e => {
                            setValues({
                                ...values,
                                idFrecuenciaDiscapacidad: e.target.value,
                                idAlcanceDiscapacidad: ""
                            })
                        }}
                        menuItems={FRECUENCIA_DISCAPACIDAD_LIST.map(s => ({ value: s.id, label: s.descripcion }))}
                        disabled={!values.idTipoDiscapacidad}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SelectGeneric
                        label="Alcance de discapacidad"
                        value={values.idAlcanceDiscapacidad}
                        onChange={e => {
                            setValues({
                                ...values,
                                idAlcanceDiscapacidad: e.target.value
                            })
                        }}
                        menuItems={ALCANCE_DISCAPACIDAD_LIST.map(s => ({ value: s.id, label: s.descripcion }))}
                        disabled={!values.idFrecuenciaDiscapacidad}
                    />
                </Grid>
            </Grid>
        </GenericModal>
    )
}